import { render, staticRenderFns } from "./ProgramareNoua.vue?vue&type=template&id=057ceca4"
import script from "./ProgramareNoua.vue?vue&type=script&lang=js"
export * from "./ProgramareNoua.vue?vue&type=script&lang=js"
import style0 from "./ProgramareNoua.vue?vue&type=style&index=0&id=057ceca4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_lodash@4.17.23_vue-template-compiler@2.7.16_webpack@5.105.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports